import type { AutoGeneratorForFormModel } from "@/components/features/_model/types/auto-generator-for-form-model";

import type { RoomI18nInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID", "roomID", "lang"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type ProductRoomI18nFormModel = AutoGeneratorForFormModel<RoomI18nInputZodSchemaType, ExcludeKeys, QueryData>;

export type QueryData = undefined;
